import styled from 'styled-components';

export const PlayerSurface = styled.div`
  width: 100%; position: relative; border-radius: 12px; overflow: hidden;
  background: #17283d; color: #fff;
  && video, && iframe {display: block; width: 100%; height: auto; aspect-ratio: 16 / 9; max-height: none; border: 0; object-fit: contain;}
  && audio {display: block; width: 100%; margin: 16px 0;}
  button:focus-visible, a:focus-visible {outline: 3px solid #ffb09c; outline-offset: -3px;}
`;
export const PlayerStatus = styled.div`
  padding: 16px; font-size: 14px; line-height: 1.6; text-align: center;
  a {color: #b9dcff; text-decoration: underline; margin: 8px;}
  button {background: #fff; color: #23354b; border: 0; border-radius: 8px; padding: 10px 16px; cursor: pointer;}
`;
export const LessonCard = styled.div`
  background: #fff; border: 1px solid #dfe6ef; border-radius: 14px; overflow: hidden;
  color: #24364c; text-align: left; box-shadow: 0 4px 16px rgba(28,48,73,.05);
  margin: 8px 0 16px;
  && img {max-height: none;}
`;
export const LessonCardHeader = styled.div`
  display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 14px 16px;
  strong {font-size: 15px;} span {font-size: 12px; font-weight: 600; border-radius: 20px; background: #edf3fa; color: #365573; padding: 5px 10px;}
`;
export const PosterButton = styled.button`
  position: relative; display: grid; place-items: center; width: 100%; aspect-ratio: 16 / 9;
  border: 0; padding: 0; cursor: pointer; color: #fff; background: linear-gradient(125deg,#153b6b,#a5677c);
  && img {position: absolute; width: 100%; height: 100%; object-fit: cover;}
  span {z-index: 1; border-radius: 28px; padding: 12px 20px; background: rgba(15,33,56,.8); font-weight: 600;}
  &:focus-visible {outline: 3px solid #ff907a; outline-offset: -3px;}
`;
export const EmptyLesson = styled.div`
  padding: 28px 20px; text-align: center; color: #52677e; background: #f7f9fc;
  p {margin: 8px 0; line-height: 1.5;} strong {color: #24364c;}
  && img {display: block; width: 180px; max-width: 80%; height: auto; margin: 0 auto 16px;}
  button {border: 0; border-radius: 8px; background: #244f7c; color: white; padding: 12px 18px; cursor: pointer;}
`;
export const AudioCover = styled.img`
  && {display: block; width: 100%; height: 180px; max-height: none; object-fit: contain; background: #eef3fa;}
`;
